import React from "react";
import HyperLogo from "../../Images/HyperLogo.png";
import Panel from "../UI/Panel/Panel.js";

export default function HoldingPage() {
  return (
    <div className="flex flex-col items-center justify-center bg-gray-50 min-h-screen">
      <div className="flex flex-col items-center">
        <img className="h-8 mb-8" src={HyperLogo} alt="Hyper" />

        <Panel className="w-[28rem]">
          <div className="flex flex-col items-center text-center">
            <p className="text-gray-600 mb-6">
              Insights is not available with your subscription. Please contact
              Hyper to upgrade.
            </p>
          </div>
        </Panel>
      </div>
    </div>
  );
}
